// ─── constants/helpContent/index.js ────────────────────────────────────────
// Aggregates every Help Center category into one list, plus small lookup and
// search helpers so the three Help Center pages (hub, category, article) all
// read from one source instead of each re implementing the same lookups.
import gettingStarted from './gettingStarted';
import buying from './buying';
import selling from './selling';
import jobPostings from './jobPostings';
import payments from './payments';
import messaging from './messaging';
import academy from './academy';
import account from './account';
import community from './community';

export const HELP_CATEGORIES = [
  gettingStarted,
  buying,
  selling,
  jobPostings,
  payments,
  messaging,
  academy,
  community,
  account,
];

export function getHelpCategory(categorySlug) {
  return HELP_CATEGORIES.find((c) => c.slug === categorySlug) || null;
}

export function getHelpArticle(categorySlug, articleSlug) {
  const category = getHelpCategory(categorySlug);
  if (!category) return { category: null, article: null };
  const article = category.articles.find((a) => a.slug === articleSlug) || null;
  return { category, article };
}

// Every article's plain text, flattened once, so search doesn't have to walk
// the block structure on every keystroke.
function articleText(article) {
  return article.body
    .map((block) => block.text || (block.items || []).join(' '))
    .join(' ');
}

const SEARCH_INDEX = HELP_CATEGORIES.flatMap((category) => category.articles.map((article) => ({
  category,
  article,
  haystack: `${article.title} ${article.summary} ${articleText(article)}`.toLowerCase(),
})));

// Simple substring match over title, summary, and body. The Help Center is a
// few dozen short articles, not thousands, so a real search index would be
// overkill for what a plain filter already does instantly.
export function searchHelpArticles(query) {
  const q = query.trim().toLowerCase();
  if (!q) return [];
  return SEARCH_INDEX
    .filter((entry) => entry.haystack.includes(q))
    .map((entry) => ({ category: entry.category, article: entry.article }));
}
